var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"home"},[_c('div',{staticClass:"hero"},[_c('h1',[_vm._v("Page Not Found!")]),_c('h2',[_vm._v("Verify that you clicked the right link.")]),_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_vm._v(" Or go back to the home page")])],1)]),_c('Main'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }